export default "__VITE_ASSET__BiBYcWO$__"